import React from 'react'
import {Col, Block} from 'jsxstyle'
import Tooltip from '../Tooltip/Tooltip'

interface ToolbarButtonProps {
  tooltipName: string
  isActive?: boolean
  onClick: () => void
  onMouseEnter: (name: string) => void
  onMouseLeave: () => void
  hoveredTooltip: string | null
  icon: React.ReactNode
  tooltipText: string
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  tooltipName,
  isActive = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  hoveredTooltip,
  icon,
  tooltipText,
}) => {
  return (
    <Col width="auto">
      <Block
        component="button"
        padding="6px"
        marginRight="4px"
        borderRadius="4px"
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="center"
        backgroundColor={hoveredTooltip === tooltipName ? '#f0f0f0' : 'transparent'}
        color={isActive ? '#0E78F5' : '#555'}
        border="none"
        props={{
          onClick,
          onMouseEnter: () => onMouseEnter(tooltipName),
          onMouseLeave,
        }}
        transition="all 0.2s ease"
        position="relative"
      >
        {icon}
        <Tooltip name={tooltipName} hoveredTooltip={hoveredTooltip}>
          {tooltipText}
        </Tooltip>
      </Block>
    </Col>
  )
}

export default ToolbarButton
